import {
    SETTING_POST_REQUEST,
    SETTING_POST_SUCCESS,
    SETTING_POST_FAIL,
    ADD_SURAH_SUCCESS,
    ADD_SURAH_FAIL,
    ADD_SURAH_REQUEST,
    GET_SURAH_SUCCESS,
    GET_SURAH_FAIL,
    GET_SURAH_REQUEST,
    EDIT_REVIEW_SUCCESS,
    EDIT_REVIEW_FAIL,
    EDIT_REVIEW_REQUEST,
    SHIFT_TOMORROW_TODAY_SUCCESS,
    SHIFT_TOMORROW_TODAY_FAIL,
    SHIFT_TOMORROW_TODAY_REQUEST,
    DELETE_REVIEW_SUCCESS,
    DELETE_REVIEW_REQUEST,
    DELETE_REVIEW_FAIL,
    POSTPONE_TODAY_SUCCESS,
    POSTPONE_TODAY_REQUEST,
    POSTPONE_TODAY_FAIL,
    POSTPONE_ALL_REVIEW_SUCCESS,
    POSTPONE_ALL_REVIEW_REQUEST,
    POSTPONE_ALL_REVIEW_FAIL,
    CHANGE_ALL_SURAH_TO_REVIEW_SUCESS,
    CHANGE_ALL_SURAH_TO_REVIEW_FAIL,
    CHANGE_ALL_SURAH_TO_REVIEW_REQUEST,
    SAVE_SURAH_AS_COMPLETE_SUCCESS,
    SAVE_SURAH_AS_COMPLETE_REQUEST,
    SAVE_SURAH_AS_COMPLETE_FAIL,
    GET_REVIEW_SURAHS_SUMMARY_SUCCESS,
    GET_REVIEW_SURAHS_SUMMARY_FAIL,
    GET_REVIEW_SURAHS_SUMMARY_REQUEST,
    GET_STATISTICS_SUCCESS,
    GET_STATISTICS_FAIL,
    GET_STATISTICS_REQUEST

} from './types';



import axios from 'axios';
// import { REACT_APP_API_URL } from '../constants';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

export const postSettings = (data) => async (dispatch) => {
  dispatch({ type: SETTING_POST_REQUEST });
  const accessToken = localStorage.getItem('access');
  
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };

      try {
        const res = await axios.post(`${REACT_APP_API_URL}user-settings/`, data, config);
        dispatch({
          type: SETTING_POST_SUCCESS,
          payload: res.data,
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: SETTING_POST_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
      }
    } else {
      dispatch({
        type: SETTING_POST_FAIL,
        payload: 'No access token found',
      });
    }
  };


export const addSurah = (data) =>  async (dispatch) => {
  dispatch({ type: ADD_SURAH_REQUEST });
  const accessToken = localStorage.getItem('access');
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };

      try {
        const res = await axios.post(`${REACT_APP_API_URL}add-surah-to-memorization/`, data, config);
        dispatch({
          type: ADD_SURAH_SUCCESS,
          payload: res.data,
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: ADD_SURAH_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
      }
    } else {
      dispatch({
        type: ADD_SURAH_FAIL,
        payload: 'No access token found',
      });
    }
  }


  


export const getSurah = () => async (dispatch) => {
  dispatch({ type: GET_SURAH_REQUEST });
  const accessToken = localStorage.getItem('access');
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };

      try {
        const res = await axios.get(`${REACT_APP_API_URL}get-user-reviews/`, config);
        dispatch({
          type: GET_SURAH_SUCCESS,
          payload: res.data,
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: GET_SURAH_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
      }
    } else {
      dispatch({
        type: GET_SURAH_FAIL,
        payload: 'No access token found',
      });
    }
  }


  export const editReview = ({ review_id, request_type, rating }) => async (dispatch) => {
    dispatch({ type: EDIT_REVIEW_REQUEST });
    const accessToken = localStorage.getItem('access');
  
    if (accessToken) {
      const config = {
        headers: {
          'Content-Type' : 'application/json',
          'Authorization' : `JWT ${accessToken}`
        }
      };
  
      try {
        const payload = { review_id, request_type };
        if (rating !== undefined) payload.rating = rating;
        const res = await axios.post(`${REACT_APP_API_URL}edit-user-reviews/`, payload, config);
        // const res = await axios.post(`${REACT_APP_API_URL}edit-user-reviews/`, data, config);
        dispatch({ type: EDIT_REVIEW_SUCCESS, payload: res.data });
        // FIX #3: Fetch stats immediately after editing
        await dispatch(getStatistics());
        return res.data;
      } catch (err) {
        const msg = err.response?.data?.detail || 'Error editing review';
        dispatch({ type: EDIT_REVIEW_FAIL, payload: msg });
        throw err;
      }
    } else {
      dispatch({ type: EDIT_REVIEW_FAIL, payload: 'No access token found' });
      throw new Error('No access token found');
    }
  };
  


export const shiftTomorrowToday = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: SHIFT_TOMORROW_TODAY_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };
      const review_id = data.review_id; // Extract the review ID from the data object

      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: SHIFT_TOMORROW_TODAY_SUCCESS,
          payload: {review_id, ...res.data,},
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: SHIFT_TOMORROW_TODAY_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: SHIFT_TOMORROW_TODAY_FAIL,
        payload: 'No access token found',
      });
    }
  }


export const deleteReview = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: DELETE_REVIEW_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };
      const review_id = data.review_id; 
      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: DELETE_REVIEW_SUCCESS,
          payload: {review_id, ...res.data,},
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: DELETE_REVIEW_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: DELETE_REVIEW_FAIL,
        payload: 'No access token found',
      });
    }
  }

export const postponeToday = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: POSTPONE_TODAY_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };
      const review_id = data.review_id; 

      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: POSTPONE_TODAY_SUCCESS,
          payload: {review_id, ...res.data,},
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: POSTPONE_TODAY_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: POSTPONE_TODAY_FAIL,
        payload: 'No access token found',
      });
    }
  }


export const postponeAllReview = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: POSTPONE_ALL_REVIEW_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };
      const review_id = data.review_id; 
      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: POSTPONE_ALL_REVIEW_SUCCESS,
          payload: {review_id, ...res.data,},
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: POSTPONE_ALL_REVIEW_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: POSTPONE_ALL_REVIEW_FAIL,
        payload: 'No access token found',
      });
    }
  }


export const changeAllSurahToReview = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: CHANGE_ALL_SURAH_TO_REVIEW_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };

      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: CHANGE_ALL_SURAH_TO_REVIEW_SUCESS,
          payload: res.data,
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: CHANGE_ALL_SURAH_TO_REVIEW_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: CHANGE_ALL_SURAH_TO_REVIEW_FAIL,
        payload: 'No access token found',
      });
    }
  }


export const saveSurahAsComplete = (data) => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: SAVE_SURAH_AS_COMPLETE_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };
      const review_id = data.review_id; 
      try {
        const res = await axios.post(`${REACT_APP_API_URL}edit-reviews/`, data, config);
        dispatch({
          type: SAVE_SURAH_AS_COMPLETE_SUCCESS,
          payload: {review_id, ...res.data,},
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: SAVE_SURAH_AS_COMPLETE_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
        throw err;
      }
    } else {
      dispatch({
        type: SAVE_SURAH_AS_COMPLETE_FAIL,
        payload: 'No access token found',
      });
    }
  }



export const getReviewSurahsSummary = () => async (dispatch) => {
  const accessToken = localStorage.getItem('access');
  dispatch({ type: GET_REVIEW_SURAHS_SUMMARY_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
              'Content-Type' : 'application/json',
              'Authorization' : `JWT ${accessToken}`
        }
      };

      try {
        const res = await axios.get(`${REACT_APP_API_URL}get-user-reviews-summary/`, config);
        dispatch({
          type: GET_REVIEW_SURAHS_SUMMARY_SUCCESS,
          payload: res.data,
        });
        return res.data; // Return the response data if needed
        // Switch from GET to POST, pass "data" as the second argument
    
      } catch (err) {
        dispatch({
          type: GET_REVIEW_SURAHS_SUMMARY_FAIL,
          payload: err.response?.data || 'Error in posting user settings'
        });
      }
    } else {
      dispatch({
        type: GET_REVIEW_SURAHS_SUMMARY_FAIL,
        payload: 'No access token found',
      });
    }
  }



  export const getStatistics = () => async (dispatch) => {
    const accessToken = localStorage.getItem('access');
    dispatch({ type: GET_STATISTICS_REQUEST });
  
    if (accessToken) {
      const config = {
        headers: {
          'Content-Type' : 'application/json',
          'Authorization' : `JWT ${accessToken}`
        }
      };
  
      try {
        const res = await axios.get(`${REACT_APP_API_URL}get-user-statistics/`, config);
        dispatch({ type: GET_STATISTICS_SUCCESS, payload: res.data });
        return res.data;
      } catch (err) {
        // FIX #1: Correct error message
        const msg = err.response?.data?.detail || 'Error fetching statistics';
        dispatch({ type: GET_STATISTICS_FAIL, payload: msg });
        // FIX #2: Re-throw so any awaiting component knows it failed
        throw err;
      }
    } else {
      dispatch({ type: GET_STATISTICS_FAIL, payload: 'No access token found' });
    }
  };